import ApiService from '@/store/ApiService.js'

const musicPlayerModule = {
  state: {
    playerPlayList: [],
    nowSelectedPlayList: [],
    shuffleFlag: false,
    shufflePlayList: [],
    notShufflePlayList: [],
    isShufflePlay: false,
    isPlaying: false,
    nowPlayListType: null,
    nowPlayTune: {
      index: null,
      title: '',
      artist: '',
      artistId: '',
      artistImage: '',
      src: '',
      lyrics: '',
      rank: null,
      productId: null,
      resultsCount: null
    },
    playerDialog: false,
    repeatFlag: null,
    disableBtnPrev: false,
    disableBtnNext: false
  },
  mutations: {
    /**
     * 再生/停止かのステータスをセットするメソッド
     * @param state
     * @param boolean
     */
    musicPlayerModuleUpdateIsPlaying (state, boolean) {
      state.isPlaying = boolean
    },
    musicPlayerModuleUpdateShufflePlayList (state, playList) {
      state.shufflePlayList = playList
    },
    musicPlayerModuleUpdateNotShufflePlayList (state, playList) {
      state.notShufflePlayList = playList
    },
    async musicPlayerModuleUpdateNowSelectedPlayList (state, playList) {
      let index = 0
      let result = []
      Object.keys(playList).map(function (key) {
        result[index] = playList[key]
        result[index]['index'] = index
        index = index + 1
      })
      state.nowSelectedPlayList = result
    },
    musicPlayerModuleUpdateNowPlayTune (state, [index, title, artistId, productId, src, lyrics, rank, resultsCount]) {
      state.nowPlayTune.index = parseInt(index) >= 0 ? parseInt(index) : 0
      state.nowPlayTune.title = title
      state.nowPlayTune.src = src
      state.nowPlayTune.lyrics = lyrics
      state.nowPlayTune.productId = productId
      state.nowPlayTune.rank = rank
      state.nowPlayTune.resultsCount = resultsCount
      this.dispatch('musicPlayerModuleApiGetNowPlayTuneArtistInfo', artistId)
    },
    musicPlayerModuleUpdateRepeatFlag (state, flag) {
      state.repeatFlag = flag
    },
    musicPlayerModuleStartPlayList (state, [index, playListType]) {
      state.nowPlayListType = playListType
      this.commit('musicPlayerModuleSetPlayList', playListType)
      this.commit('musicPlayerModuleSetPlayListTuneByIndex', index)
      this.commit('musicPlayerModuleUpdateNotShufflePlayList', this.getters.musicPlayerModuleGetNowSelectedPlayList)
    },
    musicPlayerModuleSetPlayList (context, playListType) {
      let playList = {}
      switch (playListType) {
        case 'playListA':
          playList = this.getters.getPlayListA
          break
        case 'playListB':
          playList = this.getters.getPlayListB
          break
        case 'artist':
          playList = this.getters.artistListModuleGetArtistList
          break
        case 'recommend':
          playList = this.getters.recommendListModuleGetRecommendedList
          break
        case 'favorite':
          playList = this.getters.getFavoriteList
          break
        case 'search':
          playList = this.getters.getSearchResult
          break
        case 'searchShufflePlay':
          playList = context.shufflePlayList
          break
        case 'ranking':
          playList = this.getters.getRankingList
          break
      }
      this.commit('musicPlayerModuleUpdateNowSelectedPlayList', playList)
      return playList
    },
    musicPlayerModuleSetPlayListTuneByIndex (state, index) {
      const nowSelect = this.getters.musicPlayerModuleGetNowSelectedPlayList
      console.log(nowSelect)
      const tune = nowSelect[index]
      this.commit('musicPlayerModuleUpdateNowPlayTune', [index, tune.name, tune.artist_id, tune.product_id, tune.mp3, tune.lyrics, tune.rank, tune.resultsCount])
      return state.nowSelectedPlayList[index]
    },
    musicPlayerModuleShuffle (state, isShuffle) {
      state.isShufflePlay = isShuffle
      if (state.isShufflePlay) {
        this.commit('musicPlayerModuleUpdateNowSelectedPlayList', state.shufflePlayList)
      } else {
        this.commit('musicPlayerModuleUpdateNowSelectedPlayList', state.notShufflePlayList)
      }
    },
    musicPlayerModuleUpdateNowPlayTuneArtistInfo (state, artistInfo) {
      state.nowPlayTune.artistId = artistInfo.artist_id
      state.nowPlayTune.artist = artistInfo.artist_name
      state.nowPlayTune.artistImage = artistInfo.main_large_image
    }
  },
  actions: {
    async musicPlayerModuleApiGetNowPlayTuneArtistInfo (context, artistId) {
      let transactionId = this.state.transactionId
      let targetPath = 'ajax/artist.php' + '?transactionid=' + transactionId + '&artist_id=' + artistId
      let response = await ApiService.get(targetPath)
      this.commit('musicPlayerModuleUpdateNowPlayTuneArtistInfo', response.data)
    },
    /**
     * 現在の次の曲をセットさせるためのメソッド
     * @param context
     */
    musicPlayerModuleSetNextPlayTuneData (context) {
      let nowIndex = context.state.nowPlayTune.index
      let maxIndex = context.state.nowSelectedPlayList.length
      let nextIndex = nowIndex + 1
      if (nextIndex >= maxIndex) {
        nextIndex = 0
      }
      let canPlay = false
      while (!canPlay) {
        if (context.state.nowSelectedPlayList[nextIndex]) {
          if (context.state.nowSelectedPlayList[nextIndex].mp3) {
            canPlay = true
          }
        }
        if (!canPlay) {
          nextIndex = nextIndex + 1
          if (nextIndex >= maxIndex) {
            nextIndex = 0
          }
        }
      }
      this.commit('musicPlayerModuleSetPlayListTuneByIndex', nextIndex)
    },
    musicPlayerModuleSetPrevPlayTuneData (context) {
      let nowIndex = context.state.nowPlayTune.index
      let maxIndex = context.state.nowSelectedPlayList.length - 1
      let nextIndex = nowIndex - 1
      if (nowIndex <= 0) {
        nextIndex = maxIndex
      }
      let canPlay = false
      while (!canPlay) {
        if (context.state.nowSelectedPlayList[nextIndex]) {
          if (context.state.nowSelectedPlayList[nextIndex].mp3) {
            canPlay = true
          }
        }
        if (!canPlay) {
          nextIndex = nextIndex - 1
          if (nextIndex <= 0) {
            nextIndex = maxIndex
          }
        }
      }
      this.commit('musicPlayerModuleSetPlayListTuneByIndex', nextIndex)
    },
    musicPlayerModuleSetRepeatFlag (context, flag) {
      this.commit('musicPlayerModuleUpdateRepeatFlag', flag)
    }
  },
  getters: {
    musicPlayerModuleGetNowPlayTuneData (state) {
      return state.nowPlayTune
    },
    musicPlayerModuleGetNowPlayTuneMp3: state => state.nowPlayTune.src,
    musicPlayerModuleGetNowPlayTuneArtistId (state) {
      return state.nowPlayTune.artistId
    },
    musicPlayerModuleGetNowSelectedPlayList (state) {
      return state.nowSelectedPlayList
    },
    musicPlayerModuleGetIsShufflePlay (state) {
      return state.isShufflePlay
    },
    musicPlayerModuleIsRepeat (state) {
      return state.repeatFlag === 'all'
    },
    musicPlayerModuleIsOneRepeat (state) {
      return state.repeatFlag === 'one'
    },
    musicPlayerModuleIsNotRepeat (state) {
      return state.repeatFlag === null
    },
    musicPlayerModuleGetIsPlaying (state) {
      return state.isPlaying
    },
    musicPlayerModuleIsLastTune (state) {
      let nowIndex = state.nowPlayTune.index
      let notIncreasingNull = state.nowSelectedPlayList.filter(record => record.mp3 !== null)
      let maxIndex = notIncreasingNull[notIncreasingNull.length - 1] ? notIncreasingNull[notIncreasingNull.length - 1]['index'] : 0
      return nowIndex >= maxIndex
    },
    musicPlayerModuleGetNowPlayListType (state) {
      return state.nowPlayListType
    },
    musicPlayerModuleGetShufflePlayList (state) {
      return state.shufflePlayList
    }
  }
}
export default musicPlayerModule



// WEBPACK FOOTER //
// ./src/store/MusicPlayerModule.js